import * as drawerActions from '../actions/drawer.actions'

function initialState() {
  return {
    disableLoader: false,
    errorData: [],
    errorHandling: false,
    feedback: [],
    footer: { children: null, enabled: false },
    fullScreen: false,
    header: { title: '', type: 'default' },
    loader: 0,
    modalType: '',
    notifications: [],
    request: {},
    scrollable: false,
  }
}

const drawerReducer = (state = initialState(), action) => {
  const newState = state

  switch (action.type) {
    case drawerActions.UPDATE_ERROR:
      return {
        ...state,
        errorData: [...state.errorData, action.payload],
        errorHandling: true,
      }

    case drawerActions.RESET_ERROR:
      return { ...state, errorData: [], errorHandling: false }

    case drawerActions.INCREMENT_LOADER:
      return { ...state, loader: state.loader + 1 }

    case drawerActions.DECREMENT_LOADER:
      if (state.loader - 1 < 0) {
        return { ...state, loader: 0 }
      }
      return { ...state, loader: state.loader - 1 }

    case drawerActions.RESET_LOADER:
      newState.loader = 0
      return {
        ...state,
        disableLoader: false,
        loader: newState.loader,
      }

    case drawerActions.DISABLE_LOADER:
      return { ...state, disableLoader: action.payload }

    case drawerActions.SET_SCROLLABLE:
      return { ...state, scrollable: action.payload }

    case drawerActions.UPDATE_HEADER_TYPE:
      return {
        ...state,
        header: { title: '', type: 'default', ...action.payload },
      }

    case drawerActions.UPDATE_MODAL_TYPE:
      return { ...state, modalType: action.payload }

    case drawerActions.REQUEST:
      return {
        ...state,
        request:
          state.request && !Array.isArray(action.payload)
            ? { ...state.request, ...action.payload }
            : action.payload,
      }

    case drawerActions.RESET:
      // to reset especific prop of drawer
      if (Object.keys(initialState()).includes(action.payload)) {
        return { ...state, [action.payload]: initialState()[action.payload] }
      }
      return { ...state, ...initialState() }

    case drawerActions.UPDATE_FEEDBACK_ALERT:
      if (action.payload && state.feedback && state.feedback.length <= 4) {
        return { ...state, feedback: [...state.feedback, action.payload] }
      }
      return { ...state }

    case drawerActions.REMOVE_FEEDBACK_ALERT:
      return {
        ...state,
        feedback: state.feedback.filter((item) => item !== action.payload),
      }
    case drawerActions.UPDATE_FULL_SCREEN:
      return {
        ...state,
        fullScreen: action.payload,
      }
    case drawerActions.UPDATE_FULL_GRID:
      return {
        ...state,
        fullWidthGrid: action.payload,
      }
    case drawerActions.SET_FOOTER:
      return {
        ...state,
        footer: { ...state.footer, children: action.payload },
      }
    case drawerActions.SET_FOOTER_ENABLED:
      return {
        ...state,
        footer: { ...state.footer, enabled: action.payload },
      }

    default:
      return state
  }
}

export default drawerReducer
